import { render } from "./user.html?vue&type=template&id=2d16d81b&ts=true&external"
import script from "./user.ts?vue&type=script&lang=ts&external"
export * from "./user.ts?vue&type=script&lang=ts&external"

import "./user.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__